// extracted by mini-css-extract-plugin
export default {"list":"Comments_list__JCrtb","item":"Comments_item__0QFBg"};